export default __webpack_public_path__ + "static/hero-badge-desktop-e559fc30e87adf9a49f9e1f99dc86b02.webp";